import { Injectable } from '@angular/core';
import { IPromocionImpresoraData } from '@core/interfaces/entidades/promocion-impresora.entidad';
import {
	ICrearPromocionImpresoraReq,
} from '@core/interfaces/request-response/promocion-impresora.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
	providedIn: 'root',
})
export class PromocionImpresoraApiService extends BaseHttpService {
	private readonly baseUrl = `${environment.apiUrl}${environment.apiPreFix}/promociones-impresora`;

	cargar() {
		return this.withLoader(
			this.httpClient.get<IPromocionImpresoraData[]>(this.baseUrl),
		);
	}

	crear(req: ICrearPromocionImpresoraReq) {
		return this.withLoader(
			this.httpClient.post<IPromocionImpresoraData>(this.baseUrl, req),
		);
	}

	editar(id: number, data: Partial<ICrearPromocionImpresoraReq>) {
		return this.withLoader(
			this.httpClient.put<IPromocionImpresoraData>(`${this.baseUrl}/${id}`, data),
		);
	}

	toggle(id: number) {
		return this.httpClient.patch<IPromocionImpresoraData>(`${this.baseUrl}/${id}/toggle`, {});
	}

	eliminar(id: number) {
		return this.withLoader(
			this.httpClient.delete(`${this.baseUrl}/${id}`),
		);
	}
}
